import { Avatar, Box, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { appIcons, appImages } from "../../../../assets";
import InputField from "../../../../components/InputField";
import TelegramIcon from "@mui/icons-material/Telegram";
import ChatData from "../../../../json/ChatData.json";

const ChatBox = () => {
  // Reference to the chat container
  const chatContainerRef = useRef(null);

  // Scroll to the bottom of the chat container when the component renders or chat data changes
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [ChatData]); // This will run whenever ChatData changes

  return (
    <Box
      height={"100%"}
      bgcolor={"text.white"}
      borderRadius={2}
      boxShadow={"0px 2px 12px 0px #25334226"}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"space-between"}
    >
      <Stack
        p={2}
        direction={"row"}
        alignItems={"center"}
        spacing={2}
        borderBottom={"1px solid rgba(0, 0, 0, 0.12)"}
      >
        <Avatar
          src={appImages.serviceCarCleaningImg}
          sx={{
            borderRadius: 2,
            height: 45,
            width: 45,
          }}
        />
        <Box>
          <Typography variant="body1" fontWeight={500} lineHeight={"normal"}>
            ABCD School Management
          </Typography>
          <Typography variant="body2">online</Typography>
        </Box>
      </Stack>

      {/* Chat Messages Section */}
      <Box
        ref={chatContainerRef}  // Attach the reference to the chat container
        p={2}
        display={"flex"}
        flexDirection={"column"}
        height={"55vh"}
        overflow="auto"
      >
        {ChatData.map((chat) => {
          const isSender = chat.sender === "User";
          return (
            <Box
              key={chat.id}
              mb={1}
              sx={{
                color: isSender ? "text.white" : "text.black",
                alignSelf: isSender ? "flex-end" : "flex-start",
                bgcolor: isSender ? "primary.main" : "#F1F1F1",
                borderRadius: 1,
                padding: 1,
                maxWidth: "70%",
              }}
            >
              <Typography variant="body2">{chat.message}</Typography>
            </Box>
          );
        })}
      </Box>

      <Stack
        direction={"row"}
        px={2}
        py={1}
        borderTop={"1px solid rgba(0, 0, 0, 0.12)"}
        spacing={1}
      >
        <IconButton
          sx={{
            borderRadius: 2,
          }}
        >
          <img src={appIcons.greyPinIcon} width={20} />
        </IconButton>
        <InputField
          styleProps={{ flexGrow: 1 }}
          InputEndIcon={
            <IconButton
              sx={{
                borderRadius: 2,
              }}
            >
              <TelegramIcon
                sx={{
                  color: "primary.main",
                }}
              />
            </IconButton>
          }
        />
      </Stack>
    </Box>
  );
};

export default ChatBox;
